export class DataQueryPreferences {
    LoadMyDefaults: boolean;
    StartPage: string;
    DisplayRelationshipTab: boolean;
    ShowSQLTranslation: boolean;
    ShowObjectName: boolean;
   }